module.exports = __webpack_public_path__ + "static/img/novice5.5ab7dc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/novice5.jpg
// module id = m0KH
// module chunks = 1